import React, { useState } from 'react';
import produce from 'immer';

import Button, { BUTTON_TYPES } from '../components/Button';
import ColorPicker from '../components/ColorPicker';
import ControlBoard from '../components/ControlBoard';
import Dropdown from '../components/Dropdown';
import Label from '../components/Label';

import { DEFAULT_BG_COLOR } from '../constants/defaultColors';

// ---------------------------------------------------------------------------------------------------------------------------
const LINEAR_GRAD_DIRECTION_MENU = {
  RIGHT: 'right',
  LEFT: 'left',
  TOP: 'top',
  BOTTOM: 'bottom',
  TOP_RIGHT: 'top right',
  TOP_LEFT: 'top left',
  BOTTOM_LEFT: 'bottom left',
  BOTTOM_RIGHT: 'bottom right',
  // DEGREES: 'degrees'
};

// ---------------------------------------------------------------------------------------------------------------------------


export default function BackgroundController(props) {
  const { containerStyleData, setContainerStyleData, toggleBgController } = props;
  const [colorPickerVisible, toggleColorPicker] = useState(false);
  const [activeColor, setActiveColor] = useState({ index: 0, color: DEFAULT_BG_COLOR });
  // -------------------------------------------------------------------------------------

  const addColorButtonClick = () => {
    setActiveColor({
      index: containerStyleData.bgColorsList.length,
      color: DEFAULT_BG_COLOR
    });
    toggleColorPicker(true);
  };

  const onColorButtonClick = (color, index) => () => {
    setActiveColor({ index, color });
    toggleColorPicker(true);
  };

  const onDeleteColor = () => {
    const bgColorsList = [...containerStyleData.bgColorsList];
    bgColorsList.splice(activeColor.index, 1);

    const newContainerStyleData = produce(containerStyleData, draft => {
      draft.bgColorsList = bgColorsList;
      if (bgColorsList.length > 1) {
        draft.style.backgroundImage = `linear-gradient(to bottom, ${bgColorsList.join(', ')})`
      } else {
        draft.style.backgroundColor = bgColorsList[0];
        delete draft.style.backgroundImage;
      }
    });
    setContainerStyleData(newContainerStyleData);
    toggleColorPicker(false);
    setActiveColor(activeColor.index - 1);
  };

  const onColorChange = (color) => {
    setActiveColor({ index: activeColor.index, color: color.hex });
    const bgColorsList = [...containerStyleData.bgColorsList];
    bgColorsList.splice(activeColor.index, 1, color.hex);
    setContainerStyleData({
      style: {
        ...containerStyleData.style,
        backgroundColor: color.hex,
        backgroundImage: `linear-gradient(to right, ${bgColorsList.join(', ')})`
      },
      bgColorsList
    });
  };

  const onGradientDirectionChange = (direction) => {
    setContainerStyleData({
      ...containerStyleData,
      style: {
        ...containerStyleData.style,
        backgroundImage: `linear-gradient(to ${direction}, ${containerStyleData.bgColorsList.join(', ')})`
      },
    });
  }

  return (
    <ControlBoard headingLabel="Modify Background" doneText="Finish" showCancel={false} onDone={() => toggleBgController(false)}>
      <div style={{ position: 'relative' }}>
        {!colorPickerVisible && (
          <div>
            <Label>Click on coloured buttons to edit existing colors</Label>
            <div style={{ marginBottom: 10 }}>
              {containerStyleData.bgColorsList.map((color, colorIndex) => (
                <Button
                  type={BUTTON_TYPES.PILLS}
                  label={color}
                  key={color}
                  style={{ backgroundColor: color, marginRight: 5, marginTop: 5 }}
                  onClick={onColorButtonClick(color, colorIndex)}
                />
              ))}
            </div>
            <Button label="Add A New Color" onClick={addColorButtonClick} />
            {containerStyleData.bgColorsList.length > 1 && (
              <Dropdown
                label="Color Direction"
                containerStyle={{ marginTop: 40 }}
                options={Object.entries(LINEAR_GRAD_DIRECTION_MENU)}
                onMenuClick={onGradientDirectionChange}
                id="background-gradient-direction"
              />
            )}
          </div>
        )}
        {colorPickerVisible && (
          <div style={{ position: 'absolute', zIndex: 999 }}>
            <ColorPicker
              color={activeColor.color}
              onChange={onColorChange}
              onDone={() => toggleColorPicker(false)}
              onDelete={onDeleteColor}
              showDelete={containerStyleData.bgColorsList.length > 1}
            />
          </div>
        )}
      </div>
    </ControlBoard>
  );
}
